<template>
	<section class='knd-openlayers'>
		<div class='knd-relative'>
			<div id='map' ref="map" class='ol-container' tabindex="1"></div>
			<div class='knd-source'>Kaart: Kadaster</div>

			<div class='knd-legend'>
					<div class='knd-legend-label knd-legend-gearresteerd'>Arrestaties</div>

					<div class='knd-legend-label knd-legend-sinti-roma'>Sinti/Roma naar Westerbork</div>
					<div class='knd-legend-label knd-legend-woonwagenbewoners'>Woonwagenbewoners naar Westerbork</div>

				<div class='knd-legend-label knd-legend-teruggekeerd'>Vrijgelaten in Westerbork</div>
			</div>
			<Tooltip :show="showTooltip" :event="event">
				In {{active.Arrestatieplaats}} 
				{{+active['Totaal gearresteerd '] === 1 ?'werd' : 'werden'}} 
				{{active['Totaal gearresteerd ']}} 
				{{+active['Totaal gearresteerd '] === 1 ?'persoon' : 'personen'}} gearresteerd, hiervan 
				{{+active['Naar Westerbork'] === 1 ? 'ging' : 'gingen'}} 
				{{active['Naar Westerbork']}}  
				naar Westerbork. 
				<span v-if="+active['Vrijgelaten in Westerbork '] > 0">Daarvan zijn {{active['Vrijgelaten in Westerbork '] || 0}} vrijgelaten in Westerbork.</span>

			</Tooltip>
		</div>

		<SwiperVue :index="index" />
		<div class='knd-source'>Bron: Peter Jorna en Netwerk Oorlogsbronnen</div>
		<div class='knd-source'>Bijgewerkt op 3 mei 2024</div>
	</section>
</template>

<script>
import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import XYZ from 'ol/source/XYZ';
import ImageLayer from 'ol/layer/Image';
import {fromLonLat, transform} from 'ol/proj';
import {getCenter} from 'ol/extent';
import Static from 'ol/source/ImageStatic.js';
import CanvasLayer from './canvas-layer';
import OSM from 'ol/source/OSM';
import {DragPan, MouseWheelZoom, defaults  as defaultInteractions} from 'ol/interaction';


import 'ol/ol.css';
import SwiperVue from './swiper';

import * as topojson from 'topojson';
import NederlandMap from '@/assets/data/geo/Nederland_2020_wgs84.json';
import Tooltip from '@/components/tooltip-vue';
import {platformModifierKeyOnly} from 'ol/events/condition';

export const MAP_DATA = {
		// extent : [
		// 		517.9166649583499975,
		// 		280357.3062793733552098,
		// 		298812.6174092824221589,
		// 		662697.1741462710779160
		// ],

		extent : [
			3.035598350,
			50.492878118,
			7.576525257,
			53.949590008
		],


		// FIXME: on iOS we get a "Canvas area exceeds the maximum limit (width * height > 16777216)"
		// error with the high quality map, which seems pretty hard to fix.
		// So we check for user agent and provide a lower quality map
		// image :  `${__ASSETS__}/images/gemeente_1943_4326_large.jpg`,
		image :  require(`@/assets/images/gemeente_1943_4326_large.jpg`),

		initZoom : 8,

		minZoom : 7,

		maxZoom : 11,

		projection : 'EPSG:4326',
};

	const vueObject = {
		components: {
			Tooltip,SwiperVue
		},

		data: function() {
			return {
				index: undefined,
				touchDevice: "ontouchstart" in document.documentElement,
				active: {},
				showTooltip: false,
				event: undefined,
				swiperOption: {
						pagination: {
							el: '.swiper-pagination',
							type: 'fraction'
						},
						navigation: {
							nextEl: '.swiper-button-next',
							prevEl: '.swiper-button-prev'
						}
				}
			}
		},

		mounted: function() {
			this.map = MAP_DATA;
			this.renderMap();
			this.renderChart();
		},
		methods: {
			renderMap() {
				this.view = new View({
						center : transform(
								getCenter(this.map.extent),
								'EPSG:4326',
								'EPSG:3857'
						),
						enableRotation: false,
						projection: 'EPSG:3857',
						// extent: [373869.15547953517,6577573.502483197,804628.1474966173,7086483.064645109],
						smoothResolutionConstraint: false,
						minZoom : this.map.minZoom,
						maxZoom : this.map.maxZoom,
						zoom: this.map.initZoom
				});

				let imageLayer = this.getImageLayer(this.map.image)

				this.ol = new Map({
					target: this.$refs.map,
					layers: [
						// new TileLayer({
					//     source: new OSM(),
					//   }),
						imageLayer
					],
					interactions: defaultInteractions({
						doubleClickZoom: this.touchDevice ? false: true,
						dragAndDrop: false,
						dragPan: this.touchDevice ? false : true,
						keyboardPan: false,
						keyboardZoom: false,
						mouseWheelZoom: false,
						pointer: false,
						select: false
					})
					.extend([
						new DragPan({
							condition: function (event) {
								return this.getPointerCount() === 2;
							},
						}),
					]),
					view: this.view
				});

			},

			renderChart() {
				let feat = topojson.feature(NederlandMap, NederlandMap.objects.Gemeenten2020);
				var layer = new CanvasLayer({
					features: feat,
					data: this.$store.state.data,
					mouseOver: this.onMouseOver,
					mouseOut: this.onMouseOut
				});

				this.ol.addLayer(layer);

				let el =  this.view.fit([373869.15547953517,6577573.502483197,804628.1474966173,7086483.064645109], {padding: [50, 50, 50, 50]});

			},

			onMouseOver(event, d) {
				this.active = d;
				this.event = event;
				this.showTooltip = true;

				this.index = this.$store.state.data.findIndex(d => d.Arrestatieplaats === this.active.Arrestatieplaats);
			},

			onMouseOut() {
				this.active = {};
				this.event = undefined;
				this.showTooltip = false;
			},

			getImageLayer(src) {
				return new ImageLayer({
					source: new Static({
						crossOrigin: '',
						imageExtent: this.map.extent,
						imageSmoothing : false,
						projection: this.map.projection,
						url: src
					})
				});
			},			
		}
	}

	export default vueObject;
</script>